import { carrierTypes } from 'common/constants';
import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class CarrierEditForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		var Validator = validatorjs;
		Validator.register(
			'numericMinValue',
			value => {
				return 1 / value > 0;
			},
			'NUMERICMINVALUE'
		);
		Validator.register(
			'decimalLength',
			value => {
				var decimal = value.toString().split('.')[1];
				if (decimal) {
					return decimal.length <= 2;
				}
				return true;
			},
			'MINIMUMLENGHT'
		);
		Validator.register(
			'authorize',
			value => {
				const carrierType = this.$('carrierType').value;
				if (
					(carrierType.label === carrierTypes.stamps || carrierType.label === carrierTypes.ups) &&
					!value.isAuthorized
				) {
					return false;
				}
				return true;
			},
			'UNAUTHORIZED'
		);
		return {
			fields: [
				{
					name: 'name',
					label: 'CARRIERVIEW.NAME',
					rules: 'required|string',
				},
				{
					name: 'carrierType',
					label: 'CARRIERVIEW.CARRIERTYPE',
					rules: 'required',
				},
				{
					name: 'carrierWarehouses',
					label: 'CARRIERVIEW.WAREHOUSES',
				},
				{
					name: 'surplusCharge',
					label: '',
					rules: 'numeric|numericMinValue|decimalLength',
					value: 0,
				},
				{
					name: 'isPercentage',
					label: '',
				},
				{
					name: 'seller',
					label: 'CARRIERVIEW.SELLER',
				},
				{
					name: 'isThirdParty',
					label: 'CARRIERVIEW.ISTHIRDPARTYCARRIER',
				},
				{
					name: 'isCarrier',
					label: 'CARRIERVIEW.CARRIER',
				},
				{
					name: 'isPartialThirdParty',
					label: 'CARRIERVIEW.ISPARTIALTHIRDPARTY',
				},
				{
					name: 'shippingAccount',
					label: 'CARRIERVIEW.SHIPPINGACCOUNT',
				},
				{
					name: 'fedex',
					fields: [
						{
							name: 'clientId',
							label: 'CARRIERVIEW.CLIENTID',
							rules: 'string',
						},
						{
							name: 'clientSecret',
							label: 'CARRIERVIEW.CLIENTSECRET',
							rules: 'string',
						},
						{
							name: 'accountNumber',
							label: 'CARRIERVIEW.ACCOUNTNUMBER',
							rules: 'string',
						},
					],
				},
				{
					name: 'ups',
					rules: 'authorize',
					fields: [
						{
							name: 'isAuthorized',
							label: 'CARRIERVIEW.ISAUTHORIZED',
						},
						{
							name: 'clientId',
							label: 'CARRIERVIEW.CLIENTID',
						},
						{
							name: 'clientSecret',
							label: 'CARRIERVIEW.CLIENTSECRET',
						},
						{
							name: 'accessLicenseNumber',
							label: 'CARRIERVIEW.ACCESSLICENSENUMBER',
						},
						{
							name: 'shipperNumber',
							label: 'CARRIERVIEW.SHIPPERNUMBER',
						},
						{
							name: 'username', // TODO: Remove after REST API is stable
							label: 'CARRIERVIEW.USERNAME',
							rules: 'string',
						},
						{
							name: 'password', // TODO: Remove after REST API is stable
							label: 'CARRIERVIEW.PASSWORD',
							type: 'password',
							rules: 'string',
						},
						{
							name: 'refreshToken',
							label: 'CARRIERVIEW.REFRESHTOKEN',
						},
					],
				},
				{
					name: 'stamps',
					rules: 'authorize',
					fields: [
						{
							name: 'isAuthorized',
							label: 'CARRIERVIEW.ISAUTHORIZED',
							rules: 'authorize',
						},
						{
							name: 'refreshToken',
							label: '',
							rules: 'string',
						},
					],
				},
				{
					name: 'thirdPartyBilling',
					fields: [
						{
							name: 'billToAccountNumber',
							label: 'CARRIERVIEW.BILLTOACCOUNTNUMBER',
						},
						{
							name: 'billToAccountZip',
							label: 'CARRIERVIEW.BILLTOACCOUNTZIP',
						},
					],
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/carrier/forms/CarrierEditForm.js